import { combineReducers } from 'redux';
import createPassword from './create-password';
import login from './login';
import loginAzure from './login-azure';
import logout from './logout';
import resetPassword from './reset-password';
import signup from './signup/signup-req';
import status from './status';
import generalUserRegistrations from './signup/user-registration-req';
import usernameAvailability from './signup/username-availability-req';
import { signupProcessReducer } from './signup/reducer';
import { changePasswordProcessReducer } from './changePassword/reducer';
import sendInvitation from './send-invitation-req';
import sessionRefresh from './session-refresh-req';

export default combineReducers({
  createPassword,
  login,
  loginAzure,
  logout,
  resetPassword,
  signup,
  status,
  signupProcess: signupProcessReducer,
  changePasswordProcess: changePasswordProcessReducer,
  generalUserRegistrations,
  usernameAvailability,
  sendInvitation,
  sessionRefresh,
});



// WEBPACK FOOTER //
// ./src/redux/auth/index.js